<template>
    <div>
        <div class="modal fade modern-modal" id="ModalTrocaNome" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            @click="cancelar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M4 21H20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 6L18 11M4 16L7 15.5L17.2929 5.20711C17.9223 4.5777 18.9459 4.5777 19.5753 5.20711L20.7929 6.4247C21.4223 7.05411 21.4223 8.0777 20.7929 8.70711L10.5 19L4 20L5 13.5L11.7929 6.70711" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Edição de Processo</h2>
                            <p>Atualize os dados principais do processo com poucos cliques.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="form-group">
                            <label for="novoNome" class="form-label">Nome do processo</label>
                            <input v-model.trim="novoNome"
                                   id="novoNome"
                                   type="text"
                                   class="form-control"
                                   :class="{ 'border-danger': camposInvalidos.novoNome }"
                                   placeholder="Digite o novo nome" />
                        </div>

                        <div class="form-grid form-grid-2">
                            <div class="form-group">
                                <label for="novoNumero" class="form-label">Número do processo</label>
                                <input v-model.trim="novoNumero"
                                       id="novoNumero"
                                       type="text"
                                       class="form-control"
                                       :class="{ 'border-danger': camposInvalidos.novoNumero }"
                                       placeholder="Digite o novo número" />
                            </div>
                            <div class="form-group">
                                <label for="lote-unico" class="form-label">Lote Único</label>
                                <select id="lote-unico"
                                        v-model="flLoteUnico"
                                        class="form-control"
                                        :class="{ 'border-danger': camposInvalidos.flLoteUnico }">
                                    <option disabled value="">Selecione:</option>
                                    <option :value="true">Sim</option>
                                    <option :value="false">Não</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="dtFinalizacaoEstimada" class="form-label">Data de finalização estimada</label>
                                <input v-model="dtFinalizacaoEstimada"
                                       id="dtFinalizacaoEstimada"
                                       type="date"
                                       class="form-control" />
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="novaDescricao" class="form-label">Descrição do processo</label>
                            <textarea v-model.trim="novaDescricao"
                                      id="novaDescricao"
                                      class="form-control form-textarea"
                                      placeholder="Digite a nova descrição (opcional)"
                                      rows="3"></textarea>
                        </div>

                        <div class="form-group">
                            <label for="novoObjeto" class="form-label">Objeto da contratação</label>
                            <textarea v-model.trim="novoObjeto"
                                      id="novoObjeto"
                                      class="form-control form-textarea"
                                      placeholder="Digite o objeto da contratação (opcional)"
                                      rows="3"></textarea>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button" class="btn btn-modern-primary w-100" @click="salvarEdicao">Salvar alterações</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalTrocaNome',
        props: {
            showModal: Boolean,
            idProcesso: String,
            dsNome: String,
            dsProcesso: String,
            dsObjeto: String,
            cdProcesso: String,
        },
        data() {
            return {
                novoNome: '',
                novaDescricao: '',
                novoObjeto: '',
                novoNumero: '',
                dtFinalizacaoEstimada: '',
                flLoteUnico: '',
                myModalAlternative: null,
                camposInvalidos: {
                    novoNome: false,
                    novoNumero: false,
                    flLoteUnico: false,
                },
                lotes: [],
                isLoteUnico: false,
            }
        },
        methods: {
            cancelar() {
                this.novoNome = '';
                this.novaDescricao = '';
                this.novoObjeto = '';
                this.novoNumero = '';
                this.dtFinalizacaoEstimada = '';
                this.myModalAlternative.hide();
                this.$emit('close');
            },

            formatarDataInput(valor) {
                if (!valor) return '';
                const texto = String(valor);
                const data = texto.includes('T') ? texto.split('T')[0] : texto.substring(0, 10);
                return /^\d{4}-\d{2}-\d{2}$/.test(data) ? data : '';
            },

            preencherComProps() {
                this.novoNome = this.dsNome || '';
                this.novaDescricao = this.dsProcesso || '';
                this.novoObjeto = this.dsObjeto || '';
                this.novoNumero = this.cdProcesso || '';
                this.dtFinalizacaoEstimada = '';
            },

            carregarDadosProcesso() {
                return axios.get(`${urlApi}/Processo/Get/${this.idProcesso}`, { showLoading: false })
                    .then(res => {
                        const processo = res.data && res.data.success && res.data.data
                            ? res.data.data.processo
                            : null;
                        if (!processo) {
                            this.preencherComProps();
                            return;
                        }

                        this.novoNome = processo.dsNome || '';
                        this.novaDescricao = processo.dsProcesso || '';
                        this.novoObjeto = processo.dsObjeto || '';
                        this.novoNumero = processo.cdProcesso || '';
                        this.dtFinalizacaoEstimada = this.formatarDataInput(processo.dtFinalizacaoEstimada);
                    })
                    .catch(() => {
                        this.preencherComProps();
                        avisoErro("Erro ao carregar os dados do processo.");
                    });
            },

            getProcessosItensLotes() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetProcessoItemLote`, {
                    params: { idProcesso: this.idProcesso }
                }).then(res => {
                    $this.lotes = res.data.data.rows || [];
                    
                }).catch(() => {
                    avisoErro("Erro ao buscar lotes.");
                });
            },

            VerificaLoteUnico() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/VerificaLoteUnico`, { params: { idProcesso: this.idProcesso } })
                    .then(res => {
                        if (res.data) {
                            var result = res.data.data;
                            $this.isLoteUnico = result.isLoteUnico;
                        } else {
                            avisoErro("Não foi possível verificar se o lote é único.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar configuração.");
                    });
            },

            async salvarEdicao() {
                this.camposInvalidos.novoNome = !this.novoNome?.trim();
                this.camposInvalidos.novoNumero = !this.novoNumero?.trim();
                this.camposInvalidos.flLoteUnico = this.flLoteUnico === '';

                // validação especial: se ele tem mais de 1 lote e quer colocar como "Sim", dá erro
                if (this.flLoteUnico === true && this.lotes.length > 1) {
                    avisoErro("Você não pode marcar o processo como 'Lote Único' enquanto houver mais de um lote. Por favor, remova os lotes adicionais antes de fazer esta mudança.");
                    return;
                }

                const invalido = Object.values(this.camposInvalidos).some(c => c);
                if (invalido) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return;
                }

                try {
                    let response = await axios.post(`${urlApi}/Processo/Editar`, {
                        idProcesso: this.idProcesso,
                        novoNome: this.novoNome,
                        novaDescricao: this.novaDescricao,
                        novoNumero: this.novoNumero,
                        flLoteUnico: this.flLoteUnico,
                        novoObjeto: this.novoObjeto,
                        dtFinalizacaoEstimada: this.dtFinalizacaoEstimada || null
                    });

                    if (response.data.success) {
                        avisoToast("Processo editado com sucesso.");
                        this.cancelar();
                        this.$emit('nome-alterado');
                    } else {
                        avisoErro(response.data.msg || "Erro ao alterar nome.");
                    }
                } catch (error) {
                    avisoErro("Erro ao comunicar com o servidor.");
                }
            }

        },

        mounted() {
            this.myModalAlternative = new window.bootstrap.Modal('#ModalTrocaNome');

            const modalEl = document.getElementById('ModalTrocaNome');

            modalEl.addEventListener('hidden.bs.modal', () => {
                this.$emit('close');
            });
        },

        watch: {
            async showModal(newValue) {
                if (newValue) {
                    this.myModalAlternative.show();

                    await this.carregarDadosProcesso();
                    await this.getProcessosItensLotes();
                    await this.VerificaLoteUnico();

                    if (this.isLoteUnico === true || this.isLoteUnico === null || this.isLoteUnico === undefined) {
                        this.flLoteUnico = true;
                    } else {
                        this.flLoteUnico = false;
                    }
                }
            }
        },

    }
</script>

<style lang="scss" scoped>
    :deep(.modern-modal) {
        .modal-modern-content {
            border-radius: 20px;
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
            position: relative;
            overflow: visible;
        }

        .modal-modern-header {
            display: flex;
            align-items: flex-start;
            gap: 18px;
            padding: 32px 32px 20px;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 32px;
                right: 32px;
                height: 1px;
                background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
            }

            .header-icon {
                width: 60px;
                height: 60px;
                border-radius: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(14, 165, 233, 0.18) 0%, rgba(59, 130, 246, 0.18) 100%);
                color: #0ea5e9;
            }

            .header-text {
                h2 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 700;
                    color: #0f172a;
                }

                p {
                    margin-top: 6px;
                    margin-bottom: 0;
                    color: #475569;
                    font-size: 14px;
                    max-width: 420px;
                    line-height: 1.4;
                }
            }
        }

        .modal-modern-body {
            padding: 28px 32px;
            display: flex;
            flex-direction: column;
            gap: 20px;
        }

        .modal-modern-footer {
            padding: 0 32px 32px;
        }

        .form-grid {
            display: grid;
            gap: 18px;

            &.form-grid-2 {
                grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            }
        }

        .form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        .form-control {
            border-radius: 12px;
            border: 2px solid rgba(148, 163, 184, 0.25);
            background: #ffffff;
            padding: 12px 16px;
            font-size: 14px;
            color: #1f2937;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                border-color: rgba(59, 130, 246, 0.6);
                box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
                background: #ffffff;
                color: #0f172a;
            }
        }

        select.form-control {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 16px center;
            background-size: 14px 9px;
            padding-right: 46px;
            cursor: pointer;
        }

        .form-label {
            font-weight: 600;
            color: #0f172a;
            font-size: 13px;
            letter-spacing: 0.3px;
            text-transform: uppercase;
        }

        .form-textarea {
            min-height: 110px;
            resize: vertical;
        }

        .border-danger {
            border-color: #e87986 !important;
            box-shadow: 0 0 0 0.15rem rgba(196, 104, 110, 0.25);
        }

        .btn-modern-primary {
            border: none;
            border-radius: 12px;
            padding: 14px 20px;
            font-weight: 700;
            letter-spacing: 0.3px;
            text-transform: uppercase;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
            color: #ffffff !important;
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
                color: #ffffff !important;
            }

            &:active {
                transform: translateY(0);
            }
        }

        .btn-md {
            z-index: 1001;
        }

        @media (max-width: 768px) {
            .modal-modern-header,
            .modal-modern-body,
            .modal-modern-footer {
                padding: 24px 20px;
            }

            .modal-modern-header {
                flex-direction: column;
                align-items: stretch;
                gap: 14px;

                &::after {
                    left: 20px;
                    right: 20px;
                }

                .header-icon {
                    width: 56px;
                    height: 56px;
                }
            }
        }

        @media (max-width: 576px) {
            .modal-dialog {
                margin: 12px;
            }

            .modal-modern-header .header-text {
                h2 {
                    font-size: 22px;
                }

                p {
                    font-size: 13px;
                }
            }
        }
    }

    :deep([data-bs-theme="dark"] .modern-modal) {
        .modal-modern-content {
            background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
        }

        .modal-modern-header {
            .header-icon {
                background: linear-gradient(135deg, rgba(14, 165, 233, 0.28) 0%, rgba(59, 130, 246, 0.28) 100%);
                color: #38bdf8;
            }

            .header-text {
                h2 {
                    color: #f8fafc;
                }

                p {
                    color: #94a3b8;
                }
            }
        }

        .form-control {
            background: rgba(15, 23, 42, 0.8);
            border-color: rgba(148, 163, 184, 0.2);
            color: #e2e8f0;

            &:focus {
                background: rgba(15, 23, 42, 0.95);
                color: #f8fafc;
            }
        }

        select.form-control {
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        }

        .form-label {
            color: #e2e8f0;
        }

        .btn-modern-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
        }

        .btn-md {
            background: rgba(15, 23, 42, 0.92) !important;
            border-color: rgba(148, 163, 184, 0.35) !important;

            svg {
                color: #e2e8f0;
            }
        }
    }
</style>

